import * as api from "Api";
import * as actions from "Actions";

export const fetchTaskTypeList = (limited = true, firstCall = false) => {
  return (dispatch, getState) => {
    const { id } = getState().auth.currentOrganization;
    const { paginationPage, pageSize } = getState().taskTypes.list;
    const { selected } = getState().taskTypes.categories;
    const { label } = getState().taskTypes.list.filter;

    return dispatch(
      actions.fetchTaskTypeList(
        api.getTaskTypes(
          {
            id,
            paginationPage,
            pageSize,
            categories: selected,
            firstCall,
            limited
          },
          label
        )
      )
    );
  };
};

export const fetchTaskTypeItems = () => {
  return (dispatch, getState) => {
    const { id } = getState().auth.currentOrganization;
    const { paginationPage, pageSize } = getState().taskTypes.list;
    const { selected } = getState().statistics.categories;
    const { label } = getState().taskTypes.list.filter;
    return dispatch(
      actions.fetchTaskTypeList(
        api.getTaskTypes(
          {
            id,
            paginationPage,
            pageSize,
            categories: [selected.id],
            firstCall: false,
            limited: false
          },
          label
        )
      )
    );
  };
};

export const fetchNonCategorizedTaskTypeCount = () => {
  return (dispatch, getState) => {
    const { id } = getState().auth.currentOrganization;
    return dispatch(
      actions.fetchNonCategorizedTaskTypeCount(
        api.getNonCategorizedTaskTypeCount({ id })
      )
    );
  };
};

export const fetchTaskCategoryList = () => {
  return (dispatch, getState) => {
    const { id } = getState().auth.currentOrganization;
    return dispatch(actions.fetchTaskCategoryList(api.getTaskCategories(id)));
  };
};

export const correlateTaskType = (id, from, isBillable) => {
  return (dispatch, getState) => {
    const { selected } = getState().taskTypes.list;
    const organization = getState().auth.currentOrganization.id;

    return dispatch(
      actions.saveCorrelationTaskType(
        api.correlateTaskType({
          organizationId: organization,
          categoryId: from === "category" ? id : null,
          valuationId: from === "valuation" ? id : null,
          actionOn: from,
          isBillable: isBillable !== "" ? (isBillable === true ? 1 : 0) : -1,
          data: JSON.stringify(selected)
        })
      )
    );
  };
};

export const liberateTaskType = (type, from) => {
  return (dispatch, getState) => {
    const organization = getState().auth.currentOrganization.id;

    return dispatch(
      actions.saveCorrelationTaskType(
        api.correlateTaskType({
          organizationId: organization,
          categoryId: null,
          valuationId: null,
          actionOn: from,
          isBillable: -1,
          data: JSON.stringify([type.id])
        })
      )
    );
  };
};

export const toggleBillableTaskType = (id, organizationId) => (
  dispatch,
  getState
) => {
  return dispatch(
    actions.toggleBillableTaskType(
      api.toggleBillableTask({
        organizationId: organizationId,
        id: id
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/types.js